import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/figures/progile_photo.png';

const _withScopeId = n => (_pushScopeId("data-v-083e2df9"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "navbar navbar-expand-md navbar-dark bd-navbar"
};
const _hoisted_2 = {
  class: "container-xxl navbar-nav flex-wrap flex-md-nowrap",
  "aria-label": "Main navigation"
};
const _hoisted_3 = {
  class: "d-flex flex-sm-row"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "avatar"
}, null, -1));

const _hoisted_5 = {
  class: "navbar-brand nav-link"
};
import { onMounted, onUnmounted } from 'vue'; // onMounted(() =>{
//   console.log('PageHeader 挂载了');
// });
// onUnmounted(()=>{
//   console.log('PageHeader 卸载了');
// });

export default {
  __name: 'PageHeader',

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("header", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_renderSlot(_ctx.$slots, "topLeft"), _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("a", _hoisted_5, [_createElementVNode("strong", null, _toDisplayString(_ctx.$globalParams.real_name), 1)])]), _renderSlot(_ctx.$slots, "topLeftCollapsed")])])]);
    };
  }

};